import { useCallback } from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { GlobalToolbarButton, GlobalToolbarDivider, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import { useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { MINI_TRIAL_GUIDE_COMPONENT } from 'navigation-components/config';
import { setMiniTrialGuideState } from '../utils/localStorage';
import { useDndWidget } from '../../common/hooks/useDndWidget';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MiniTrialGuideButton = ({
  itemName,
  additionalListItemStyles
}) => {
  const {
    toggle
  } = useToggleComponent(MINI_TRIAL_GUIDE_COMPONENT);
  useDndWidget(MINI_TRIAL_GUIDE_COMPONENT);
  const {
    isOpen: isMiniTrialGuideOpen
  } = useComponentState(MINI_TRIAL_GUIDE_COMPONENT);
  const handleToggle = useCallback(() => {
    toggle();
    void setMiniTrialGuideState(!isMiniTrialGuideOpen);
  }, [toggle, isMiniTrialGuideOpen]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: `Global Toolbar - ${itemName}`,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GlobalToolbarButton, {
        "data-test-id": "mini-trial-guide-button",
        id: "mini-trial-guide-button",
        itemName: "Trial Guide",
        iconName: ICON_NAMES.MINI_TRIAL_GUIDE,
        onClick: () => {
          handleToggle();
        },
        additionalListItemStyles: additionalListItemStyles
      }), /*#__PURE__*/_jsx(GlobalToolbarDivider, {})]
    })
  });
};